import RequestTransferAddressCreateDialog from "./requestTransferAddressCreateDialog.container";

export default RequestTransferAddressCreateDialog;
